import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Container, Row } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { Button, MenuItem } from "@mui/material";
import { Grid, TextField } from "@mui/material";
import {
  PersonSearch,
  PictureAsPdf,
  Refresh,
  SimCardDownloadRounded,
  UploadFile,
} from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import {
  exportToExcelLedger,
  exportToPDFLedger,
  getAllLedger,
  updateLedgerApVendorFields,
} from "../../api/ap_services";
import { useVendorCode } from "../../context/VendorCodeProvider";

import CommonLoader from "../../common/commonLoader";
import Breadcrumb from "../../common/breadcrumb";
import { Col } from "react-bootstrap";
import CommonCardDesign from "../../common/commonCardDesign";
import {
  ledgerApTableData,
  ledgerApTableHeader,
  ledgerApTableVendorHeader,
  ledgerApTableVendorData
} from "../../common/commonConstantAp";
import moment from "moment";
import { formatMoney } from "../../../constants/utils";
import { useNavigate } from "react-router-dom";
import CommonTableAp from "../../common/commonTableAp";
import LedgerApEditModal from "./ledgerApEditModal";
import LedgerApUploadModal from "./ledgerApUploadModal";
import LedgerApVendorDocumentUploadModal from "./ledgerApVendorDocumentUploadModal";

const useStyles = makeStyles((theme) => ({
  btnClass: {
    padding: "0.5rem 1.5rem!important",
    fontWeight: 600,
  },

  btnJust: {
    display: "flex!important",
    justifyContent: "end!important",
  },

  cardbody: {
    padding: `${theme.spacing(1.8, 1.3)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} !important`,
      margin: `${theme.spacing(0, 1)} !important`,
    },
  },

  muiGrid: {
    marginTop: "-2vh",
    [theme.breakpoints.down("sm")]: {
      lineHeight: 5,
    },
  },
}));

  const normalizeLedgerRow = (row) => {
    if (!row) return row;
    return {
      ...row,
      ledgerApId: row.ledgerApId ?? row.ledger_ap_id,
      creditAmount: row.creditAmount ?? row.credit_amount ?? "",
      vendorInvoiceValue: row.vendorInvoiceValue ?? row.vendor_invoice_value ?? "",
      vendorPaymentReceiptValue: row.vendorPaymentReceiptValue ?? row.vendor_payment_receipt_value ?? "",
      gstReturnFilingStatus: row.gstReturnFilingStatus ?? row.gst_return_filing_status ?? "",
      vendorRemarks: row.vendorRemarks ?? row.vendor_remarks ?? "",
    };
  };


const LedgerAp = () => {
  const classes = useStyles();
  const history = useNavigate();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [consolidateData, setConsolidateData] = useState([]);
  const { selectedVendorCode, selectedVendorName } = useVendorCode();
  const [ledgerEditModalOpen, setLedgerEditModalOpen] = useState(false);
  const [ledgerEditRow, setLedgerEditRow] = useState(null);
  const [ledgerUploadModalOpen, setLedgerUploadModalOpen] = useState(false);
  const [documentUploadModalOpen, setDocumentUploadModalOpen] = useState(false);

  const filterInitialValues = {
    searchFinancialYear: "FY 2025-26",
    vendorCode: "",
    searchDocumentType:""
  };  

  const [searchData, setSearchData] = useState(filterInitialValues);

  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const isVendor = (userData?.groupId ?? userData?.group_id) === 0;
  const groupId = userData?.groupId ?? userData?.group_id;

  useEffect(() => {
    if (selectedVendorCode) {
      filterData();
    }
  }, [selectedVendorCode, page, rowsPerPage]);

  const onFilterInputChange = (event) => {
    const { name, value } = event.target;
    searchData[name] = value;
    setSearchData({ ...searchData });
  };
  // const loadListData = () => {
  //   setLoading(true);
  //   getAllLedger(
  //     selectedVendorTypeId ?? "",
  //     page,
  //     rowsPerPage,
  //     searchData.searchFinancialYear,
  //     groupId
  //   ).then((res) => {
  //     setLoading(false);
  //     setData(res.response.responseObject);
  //     // setConsolidateData(res.response.responseMap.consolidateList);
  //   });
  // };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };



  const filterData = (overrideSearch, overridePage) => {
    const sd = overrideSearch ?? searchData;
    const pageToUse =
      overridePage !== undefined && overridePage !== null ? overridePage : page;
    setLoading(true);
    getAllLedger(
      selectedVendorCode ?? "",
      pageToUse,
      rowsPerPage,
      sd.searchFinancialYear,
      groupId,
      sd.searchDocumentType
    ).then((res) => {
      setLoading(false);
      const raw = res.response.responseObject ?? [];
      const total =
        res.response.responseMap?.totalCount ??
        res.response.responseMap?.totalRecords ??
        (Array.isArray(raw) ? raw.length : 0);
      setTotalCount(total);
      setData(Array.isArray(raw) ? raw : []);
    });
  };

  const onOpenLedgerEditModal = (row) => {
    setLedgerEditRow(normalizeLedgerRow(row));
    // setLedgerEditRow(row);
    setLedgerEditModalOpen(true);
  };

  const onSaveLedgerVendorFields = () => {
    const id = ledgerEditRow?.ledgerApId ?? ledgerEditRow?.ledger_ap_id;
    if (id == null) {
      toast.error("Invalid row");
      return;
    }
    setLoading(true);
    updateLedgerApVendorFields(id, {
      vendorInvoiceValue: ledgerEditRow.creditAmount ?? "",
      vendorPaymentReceiptValue: ledgerEditRow.vendorPaymentReceiptValue ?? "",
      gstReturnFilingStatus: ledgerEditRow.gstReturnFilingStatus ?? "",
      vendorRemarks: ledgerEditRow.vendorRemarks ?? "",
    }).then((res) => {
      setLoading(false);
      toast.success("Saved successfully");
      setLedgerEditModalOpen(false);
      setLedgerEditRow(null);
      filterData();
    }).catch(() => {
      setLoading(false);
      toast.error("Failed to save");
    });
  };

  const exportData = (isPdf) => {
    setLoading(true);
    const dateTime = (selectedVendorName || "Ledger")
      .replace(/\s+/g, "_")
      .concat("_", moment(new Date()).format("DD_MM_YYYY_HH_mm_SS"));
    if (isPdf) {
      exportToPDFLedger(
        selectedVendorCode ?? "",
        selectedVendorName,
        dateTime,
        searchData.searchFinancialYear,
        groupId,
        searchData.searchDocumentType
      ).then(() => {
        setLoading(false);
      });
    } else {
      exportToExcelLedger(
        selectedVendorCode ?? "",
        selectedVendorName,
        dateTime,
        searchData.searchFinancialYear,
        groupId,
        searchData.searchDocumentType
      ).then(() => {
        setLoading(false);
      });
    }
  };

  return (
    <Fragment>
      {loading ? <CommonLoader /> : null}
      <Breadcrumb title="Ledger" />
      {/* <!-- Container-fluid starts--> */}
      <Container fluid={true}>
        <Row>
   
          <Col lg={12} xs={12}>
            <Card>
              <CardBody className={classes.cardbody}>
                <Grid container spacing={1.5} className={classes.muiGrid}>
               {/* <Grid item sm={4} xs={12}>
              <TextField
                fullWidth
                label="Vendor"
                size="small"
                value={
                  selectedVendorCode
                    ? `${selectedVendorCode}${selectedVendorName ? " - " + selectedVendorName : ""}`
                    : ""
                }
                placeholder="Select vendor from header"
                InputProps={{ readOnly: true }}
              />
                  </Grid> */}
                  <Grid item sm={4} xs={12}>
                    <TextField
                      fullWidth
                      label="Financial Year"
                      size="small"
                      select
                      id="fullWidth"
                      name="searchFinancialYear"
                      value={searchData.searchFinancialYear}
                      onChange={onFilterInputChange}
                    >
                      <MenuItem value="FY 2024-25">FY 2024-25</MenuItem>
                      <MenuItem value="FY 2025-26">FY 2025-26</MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item sm={4} xs={12}>
                    <TextField
                      fullWidth
                      label="Document type"
                      size="small"
                      id="fullWidth"
                      name="searchDocumentType"
                      value={searchData.searchDocumentType}
                      onChange={onFilterInputChange}
                    />

                  </Grid>

                  <Grid
                    item
                    sm={4}
                    xs={12}
                    sx={{
                      margin: "auto",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      type="button"
                      className={classes.btnClass}
                      onClick={() => filterData()}
                    >
                      <PersonSearch></PersonSearch>
                    </Button>
                    <Button
                      color="primary"
                      sx={{ marginLeft: 1 }}
                      variant="contained"
                      type="button"
                      className={classes.btnClass}
                      onClick={() => {
                        const cleared = { ...filterInitialValues };
                        setSearchData(cleared);
                        setPage(0);
                        // Refetch immediately with reset filters + page 0 (useEffect may not run if page was already 0)
                        filterData(cleared, 0);
                      }}
                    >
                      <Refresh></Refresh>
                    </Button>
                    <Button
                      color="primary"
                      sx={{ marginLeft: 1 }}
                      variant="contained"
                      type="button"
                      className={classes.btnClass}
                      onClick={() => setLedgerUploadModalOpen(true)}
                      title="Import edited Ledger Excel (updates by ID column)"
                    >
                      <UploadFile />
                    </Button>
                    <Button
                      color="primary"
                      sx={{ marginLeft: 1 }}
                      variant="contained"
                      type="button"
                      className={classes.btnClass}
                      onClick={() => {
                        exportData(false);
                      }}
                    >
                      <SimCardDownloadRounded></SimCardDownloadRounded>
                    </Button>
                    {/* VENDOR DOCUMENT UPLOAD */}
                    {isVendor && (
                      <Button
                        color="primary"
                        sx={{ marginLeft: 1, backgroundColor: "red" }}
                        variant="contained"
                        type="button"
                        className={classes.btnClass}
                        onClick={() => setDocumentUploadModalOpen(true)}
                        title="VENDOR DOCUMENT UPLOAD"
                      >
                        <UploadFile />
                      </Button>
                    )}
                    {/* <Button
                      color="primary"
                      sx={{ marginLeft: 1 }}
                      variant="contained"
                      type="button"
                      className={classes.btnClass}
                      onClick={() => {
                        exportData(true);
                      }}
                    >
                      <PictureAsPdf></PictureAsPdf>
                    </Button> */}
                  </Grid>
                </Grid>
              </CardBody>
            </Card>
          </Col>

          <Card>
          <CardBody className={classes.cardbody}>
            <div>
              <CommonTableAp
                tableData={data}
                tableHeaders={isVendor ? ledgerApTableVendorHeader : ledgerApTableHeader}
                tableColumns={isVendor ? ledgerApTableVendorData : ledgerApTableData}
                rowsPerPageOptions={[15, 25, 50, 100]}
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ float: "right" }}
                displayPagination={true}
                from={"Ledger"}
                editMode={true}
                editId="ledgerApId"
                showPdf={true}
                showPdfForRow={(row) =>
                  ["KZ","ZP","KS","KG"].includes(
                    (row.documentType ?? row.document_type ?? "").toString().toUpperCase()
                  )
                }
                onOpenModal={onOpenLedgerEditModal}
              />
            </div>
          </CardBody>
            </Card>
        </Row>
      </Container>
      {/* <!-- Container-fluid Ends--> */}
      <LedgerApEditModal
        open={ledgerEditModalOpen}
        onCancel={() => {
          setLedgerEditModalOpen(false);
          setLedgerEditRow(null);
        }}
        onSave={onSaveLedgerVendorFields}
        ledgerRow={ledgerEditRow}
        setLedgerRow={setLedgerEditRow}
      />
      <LedgerApUploadModal
        open={ledgerUploadModalOpen}
        onCancel={() => setLedgerUploadModalOpen(false)}
        onImportComplete={filterData}
        setParentLoading={setLoading}
      />
      <LedgerApVendorDocumentUploadModal
        open={documentUploadModalOpen}
        onCancel={() => setDocumentUploadModalOpen(false)}
        vendorCode={selectedVendorCode}
        setParentLoading={setLoading}
      />
      <ToastContainer autoClose={1000} />
    </Fragment>
  );
};

export default LedgerAp;
